function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.125 14C15.125 14.1747 15.0843 14.3469 15.0062 14.5031C14.9281 14.6593 14.8147 14.7952 14.675 14.9L10.175 18.275C10.0569 18.3639 9.92244 18.4287 9.77929 18.4655C9.63613 18.5023 9.4871 18.5105 9.34077 18.4896C9.19443 18.4687 9.05367 18.4191 8.92655 18.3437C8.79943 18.2682 8.68845 18.1684 8.6 18.05C8.42098 17.8113 8.34411 17.5113 8.38631 17.2159C8.4285 16.9205 8.5863 16.654 8.825 16.475L12.875 13.4375V6.125C12.875 5.82663 12.9935 5.54048 13.2045 5.32951C13.4155 5.11853 13.7016 5 14 5C14.2984 5 14.5845 5.11853 14.7955 5.32951C15.0065 5.54048 15.125 5.82663 15.125 6.125V14ZM14 0.5C6.54463 0.5 0.5 6.54463 0.5 14C0.5 21.4554 6.54463 27.5 14 27.5C21.4554 27.5 27.5 21.4554 27.5 14C27.5 6.54463 21.4554 0.5 14 0.5Z"
});

function SvgIcAreaClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAreaClock);
export default ForwardRef;